import { ImageDataLike } from "gatsby-plugin-image";
import { graphql } from "gatsby"

export type IImage = {
  altText: string;
  gatsbyImage?: ImageDataLike;
  sourceUrl?: string;
  mimeType?: string;
};

export type IPageSettings = {
  mobileFooterImage?: IImage;
};

export type IPostTypeContext = {
  uri: string;
  language: {
    slug: Languages;
  };
  translations: ReadonlyArray<ITranslation>;
};

export type IWPImage = {
  sourceUrl?: string;
  altText?: string;
  mimeType?: string;
  gatsbyImage?: ImageDataLike;
  localFile?: {
    childImageSharp: {
      gatsbyImageData: ImageDataLike;
    };
  };
};

export type IWPLink = {
  title: string;
  target: string;
  url: string;
};

export enum Languages {
  English = "en",
  Swedish = "sv",
  Chinese = "zh",
}

export type Language = {
  code: string;
  locale: string;
  slug: string;
  name: string;
};

export type ITranslation = {
  uri: string;
  language: {
    slug: Languages;
  };
};